import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Heading from '@starbucks-web/pattern-library/lib/components/heading';
import FlexEmbed from '@starbucks-web/pattern-library/lib/components/flex-embed';
import { useModalContext } from '@starbucks-web/pattern-library/lib/components/modal-provider';
import ContentColumn from '@starbucks-web/pattern-library/lib/components/content-column';

import { updateOnboardingFlag } from 'shared/app/bundles/user';
import SessionCheck from 'shared/app/components/session-check';

import {
  cardsDisplaySelector,
  arrivedFromAccountCreateSelector,
} from '../../state/selectors/cards';
import AddCardButton from '../add-card-button';
import CardFraps from '../card-fraps';
import CardRegistrationFailureDialog, {
  CARD_REGISTRATION_FAILURE_DIALOG_ID,
} from '../card-registration-failure-dialog';
import SvcCard from '../svc-card';
import SvcCardSimple from '../svc-card-simple';
import messages from './messages';

export const CardsCollectionCrate = () => {
  const { openModal } = useModalContext();

  const cards = useSelector(cardsDisplaySelector);
  const arrivedFromAccountCreate = useSelector(
    arrivedFromAccountCreateSelector
  );
  const dispatch = useDispatch();

  const [firstCard, ...otherCards] = cards;
  const hasOtherCards = otherCards.length > 0;

  useEffect(() => {
    // Show error dialog if physical card registration fails on account create
    if (arrivedFromAccountCreate) {
      openModal({
        component: CardRegistrationFailureDialog,
        ariaLabelledBy: CARD_REGISTRATION_FAILURE_DIALOG_ID,
      });
      // Suppress welcome overlay if they enter an invalid card by marking it as seen
      dispatch(updateOnboardingFlag('didShowWelcomeOverlay', true));
    }
  }, []);

  return (
    <SessionCheck>
      <ContentColumn className="pt6" size="md">
        {firstCard && (
          <div className={`size12of12`} data-e2e="primaryCard">
            <SvcCard card={firstCard} />
          </div>
        )}
        {hasOtherCards && (
          <Heading
            className="text-upper text-bold pt6 pb5"
            size="xxs"
            tagName="h2"
          >
            <FormattedMessage {...messages.moreCardsHeader} />
          </Heading>
        )}
        <div className="grid grid--wideGutter grid--valignTop">
          {otherCards.map((card) => (
            <div className="pt1 pb3 gridItem size6of12" key={card.cardId}>
              <SvcCardSimple card={card} />
            </div>
          ))}
          <div
            className={`${
              (hasOtherCards && 'pt1') || 'pt6'
            } pb5 gridItem size6of12`}
          >
            <FlexEmbed height={62} width={100}>
              <AddCardButton className="flex items-center justify-center p0 m0 height-100" />
            </FlexEmbed>
          </div>
        </div>
        {firstCard && <CardFraps card={firstCard} />}
      </ContentColumn>
    </SessionCheck>
  );
};

export default CardsCollectionCrate;
